import React, { Component } from 'react'
import styled from 'styled-components'
import Snackbar from '@material-ui/core/Snackbar'
// import Slide from '@material-ui/core/Slide'
import { XMText } from './'

const Wrap = styled.div`
  & > div {
    bottom: 70px;
    ${props =>
      props.slideFromTop &&
      `
      bottom: auto;
      top: 5px;
      z-index: 999999999;
    `};
  }
  & > div > div {
    max-width: 275px;
    background-color: #fff;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border-radius: 100px;
    display: flex;
    justify-content: center;
  }
  position: relative;
  z-index: 99999999999999;
`

// const TransitionDown = props => <Slide {...props} direction="down" />
class Toast extends Component {
  state = {}
  render() {
    const { open, message, autoHideDuration, slideFromTop, ...props } = this.props
    return (
      <Wrap slideFromTop={slideFromTop}>
        {slideFromTop ? (
          <Snackbar
            open={open}
            autoHideDuration={autoHideDuration ? autoHideDuration : 3000}
            message={<XMText>{message}</XMText>}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            {...props}
          />
        ) : (
          <Snackbar
            open={open}
            autoHideDuration={autoHideDuration ? autoHideDuration : 3000}
            message={<XMText>{message}</XMText>}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            {...props}
          />
        )}
      </Wrap>
    )
  }
}

export default Toast



// WEBPACK FOOTER //
// ./src/components/Toast.js